import React from 'react';
import './Gifting_page_setup.css';

import {Helmet} from "react-helmet";

import MasterButton from '../../general_components/MasterButton/MasterButton.js';
import Selector_field from '../../general_components/Selector_field/Selector_field';
import GG_loader from '../../general_components/GG_loader/GG_loader';
import GGApi from '../../../utils/GGApi';
import Overlay_popup from '../../general_components/Overlay_popup/Overlay_popup';

import toggle_on from '../../../images/icons/toggle_on.png';
import toggle_off from '../../../images/icons/toggle_off.png';
import Pic_selector from '../../general_components/Pic_selector/Pic_selector';
import { Link } from 'react-router-dom';

import config from '../../../utils/config';
import amplitude from 'amplitude-js';
amplitude.getInstance().init(config.amp_key);

class Gifting_page_setup extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            
        // Mechanics:
            loading: false,
            access: '',
            open_overlay: false,
            button_active: true,

        // From db:
            user_name: 'user',
            receiver_name: 'receiver',
            gift_page_url: 'https://www.greatestgiftapp.com/gifts/',
        
        // Inputs:
            page_active: true,
            gifting_page_welcome_message: '',
            media_file: '',
            goals: [],

            original_media_file: ''
        }

        this.handleButtonClick  = this.handleButtonClick.bind(this);

        this.handleChange       = this.handleChange.bind(this);
        this.handlePicChange    = this.handlePicChange.bind(this);
        this.toggle_goal        = this.toggle_goal.bind(this);
        
        this.render_media       = this.render_media.bind(this);
        this.render_goals       = this.render_goals.bind(this);
    }


    componentDidMount() {   
        // get details from back end
       
        GGApi.get_plan_by_id(this.props.match.params.plan_id).then(response => {
            if (response.fetched_plan) {
                
                // amplitude
                amplitude.getInstance().logEvent('gifting page: view setup page', {'active_page': response.fetched_plan.page_active})

                let user_name = response.fetched_plan.first_name + ' ' + response.fetched_plan.last_name;
                let receiver_name = response.fetched_plan.account_name
                let gift_page_url = 'https://www.greatestgiftapp.com/gifts/' + response.fetched_plan.slug
                let page_active = response.fetched_plan.page_active;
                let gifting_page_welcome_message = response.fetched_plan.welcome_message;
                let media_file = response.fetched_plan.media_url;
                let original_media_file = response.fetched_plan.media_url;
                
                // clean up goals:
                let goals = response.fetched_plan.goals;
                goals = goals.split('; ');
                goals.pop();                

                // set the gifting page items from the response in the state:
                this.setState({
                    loading: false, 
                    
                    user_name: user_name,
                    receiver_name: receiver_name,
                    gift_page_url: gift_page_url,
                    
                    page_active: page_active,
                    gifting_page_welcome_message: gifting_page_welcome_message,
                    media_file: media_file,
                    original_media_file: original_media_file,
                    goals: goals
                });
            };
            if(response.access === 'No-access') {
                this.setState({loading: false, access: response.access})
            };
        });

    }

    // Button handler:

    handleButtonClick(){
        if(!this.state.button_active){
            return;
        }

        // start gg loader
        this.setState({loading: true, button_active: false})
        
        // if new media was selected - upload media
        // otherwise - don't change it
        if(this.state.media_file && this.state.media_file !== this.state.original_media_file){
            GGApi.upload_media(this.state.media_file, 'gifting-page-media').then(response => {
                // handle media upload error
                let media;
                if(response.errors){
                    alert(response.errors[0].detail + ' \nThere was an issue when attempting to upload the image. Please try again.')
                } else if(response.mediaUrl){
                    media = response.mediaUrl;
                };

                // update gifting page - 
                    // active y/n
                    // welcome message
                    // media
                    // goals
                
                // temporary - set page active as true. doesn't allow the option to toggle the page active
                //let page_active = this.state.page_active
                let page_active = true; 

                GGApi.update_gifting_page(this.props.match.params.plan_id, page_active,  this.state.gifting_page_welcome_message, media, this.state.goals)
                .then(response => {
                    if(!response.success){
                        this.setState({loading: false, button_active: true})
                        alert('There was an issue when trying to update the gifting page. Please try again, or contact our support team for further assistance.')
                    } else if (response.success){
                        // get the slug from the back-end
                        // end gg loader
                        // open a success pop up? 
                        this.setState({loading: false, open_overlay: true, button_active: false})
                        // amplitude
                        amplitude.getInstance().logEvent('gifting page: confirm gifting page', {'active_page': this.state.page_active})
                    }
                })
            });

        } else { 
            // temporary - set page active as true. doesn't allow the option to toggle the page active
            //let page_active = this.state.page_active
            let page_active = true; 
            GGApi.update_gifting_page(this.props.match.params.plan_id, page_active,  this.state.gifting_page_welcome_message, this.state.media_file, this.state.goals)
            .then(response => {
                if(!response.success){
                    this.setState({loading: false, button_active: true})
                    alert('There was an issue when trying update the gifting page. Please try again, or contact our support team for further assistance.')
                } else if (response.success){
                    // get the slug from the back-end
                    // end gg loader
                    // open a success pop up? 
                    this.setState({loading: false, open_overlay: true, button_active: false})
                    // amplitude
                    amplitude.getInstance().logEvent('gifting page: confirm gifting page', {'active_page': this.state.page_active})
                }
            })
        }
        
    }

    
    // Event handlers:

    handleChange(event) {
        const { name, value} = event.target;
        this.setState({[name]: value});
    }

    handlePicChange(event) {
        let file = event.target.files[0];
        // try to convert here to jpeg?
        if(!file){
            return;
        }
        if(file.size > 4194304) {
            alert('Please select a photo with a max size of 4MBs.');
            return;
        }
        this.setState(
            {media_file: event.target.files[0]}
        );
    }

    toggle_goal(goal){
        let goals = this.state.goals;
        let new_goals;
        let lower_case_goal = goal.toLocaleLowerCase();
        if(goals.includes(goal.toLocaleLowerCase())){
            let index = goals.findIndex( item => 
                item === lower_case_goal
            );
            new_goals = goals.slice(0, index).concat(goals.slice(index + 1));
            this.setState({goals: new_goals})
        } else {
            goals.push(goal.toLocaleLowerCase());
            this.setState({goals: goals})
        }
    }


    // Render methods:

    render_media(){
        if(!this.state.media_file){
            return null;
        } else {
            return (
                <div>
                <p className='form_label'>1. Banner Picture:</p>
                <img 
                src={this.state.media_file}
                className='gifting_page_picture' />
                <p className='cursor align_center green_text'>Change picture</p>
                </div>
            )
        }
    }

    render_goals(){
        let options = [
            'College Fund',
            'Future Savings',
            'Diaper Fund',
            'Puppy Fund',
            'House Fund',
            'First Car Fund',
            'Adulting Fund',
            'Emergency Fund',
            'Financial Independence',
            'Disney Trip Fund',
            'Crypto Fund',
            'Wedding Fund',
            'Vacation Fund'
        ];
        return options.map(goal => {
            return (
                <p  onClick={() => this.toggle_goal(goal)}
                    className={this.state.goals.includes(goal.toLocaleLowerCase()) ? 'input_button input_button_selected' : 'input_button'}>
                        {goal}
                </p>
            )
        })
    }

 
    render () {
        
        if(this.state.loading) {
            return (
                <GG_loader/>
            )
        }

        if (this.state.access === 'No-access') {
            return (
                <main>
                    <h2>We're sorry, but the page you are trying to locate is unavailable.</h2>
                </main> 
            )
        } else {
            return (
                <main>

                    <Helmet>
                        <title>{`Gifting page set up | Greatest Gift`}</title>
                    </Helmet>

                    {/* activate page (currently not relevant - webflow doesn't allow to unpublish individual items)
                    <div className='toggle_switch_container'>
                        <p>Gifting Page Active</p> 
                        <img
                            className='toggle_switch_icon' 
                            src={this.state.page_active ? toggle_on : toggle_off}
                            onClick={() => this.setState({page_active: !this.state.page_active})}
                        />
                    </div>
                    */}

                    {/* picture */}
                    {
                        
                        
                        <Pic_selector 
                        label={'1. Add a banner picture:'}
                        handlePicChange={this.handlePicChange}
                        file={this.state.media_file}
                        uploaded_file={this.state.original_media_file === this.state.media_file}
                        custom_height={"200-420"}/>
                    }
                    

                    
                    {/* welcome message */}
                    <form style={{ 'margin-top': `16px`}}>

                    <Selector_field 
                        options             = {[`${this.state.user_name} is saving for ${this.state.receiver_name}’s future! Send a gift with Greatest Gift, and invest in ${this.state.receiver_name}’s future today.\nHappy Gifting,\nYour friends at Greatest Gift.`, 
                                                `Thank you for visiting ${this.state.receiver_name}'s gifting page. Through this page, you can give cash gifts for ${this.state.receiver_name}'s long term savings.`
                                            ]}

                        label               = "2. Gifting Page Welcome Message:"
                        field_name          = "gifting_page_welcome_message"
                        field_placeholder   = {`Example: ${this.state.user_name} is saving for ${this.state.receiver_name}’s future! Send a gift with Greatest Gift, and invest in ${this.state.receiver_name}’s future today.\nHappy Gifting,\nYour friends at Greatest Gift.`}
                        field_value         = {this.state.gifting_page_welcome_message}
                        max_length          = {250}
                        randomize           = {false}
                    
                        handleChange        = {this.handleChange}
                    
                        select_item         = {(selected_item) => this.setState({gifting_page_welcome_message: selected_item})}

                    />

                    </form>

                    {/* goals */}

                    <p className='form_label'>3. Select {this.state.receiver_name}'s Financial Goals:</p>
                    <div className='input_buttons_container'>
                        {this.render_goals()}
                    </div>

                    {/* confirm button */}
                    <MasterButton 
                        buttonText={'Save Edits'} 
                        inactive_button={!this.state.button_active}
                        handleButtonClick={this.handleButtonClick}
                        notSticky={true}
                    />
                    
                    {/* cancel button */}
                    <Link to={`/plan/${this.props.match.params.plan_id}`}> 
                        <p className='cursor align_center small_text secondary_dark' >Cancel Edits</p>
                    </Link>

                    <div className='buffer'></div>
                    <div className='buffer'></div>


                    {/* success message, and share notice */}

                    <Overlay_popup 
                    open            = {this.state.open_overlay}
                    closer          = {false}
                    
                    overlay_title   = 'Gifting Page Updated!'
                    wide            = {true}
            
                    body_1          = 'Your gifting page has been updated, and is ready to be shared. Check it out and share the link with friends and family!'
                    body_2          = {this.state.gift_page_url}
                    button_1        = {{text: 'Finish',
                                        links: true,
                                        linkTo: `/plan/${this.props.match.params.plan_id}`,
                                        }}    
                />

                </main>
            )
        }
    }
}

export default Gifting_page_setup;